export enum RolesEnum {
	Buyer = 'Buyer',
	Trained = 'Trained',
	Admin = 'Admin',
}
